import React from "react";
import { Link } from "react-router-dom";

const TIMESTAMPS_LEFT = [
  { time: "2:10", label: "Motivation Isn't Enough" },
  { time: "6:18", label: "Identity Drift" },
  { time: "9:02", label: "Identifying Your False Wins" },
  { time: "20:42", label: "Beliefs, Boundaries & Budget" },
];

const TIMESTAMPS_RIGHT = [
  { time: "30:27", label: "The 3 I's Framework" },
  { time: "34:21", label: "Conversation w/ 6 Figure Earner" },
  { time: "50:51", label: "Your Guided Reflection" },
  { time: "53:55", label: "Personal Transformation" },
];

const WHAT_STAYS_THE_SAME = [
  "You keep holding everything together while quietly disappearing.",
  "You leave inspired, then return to the same patterns without support.",
  "The dream stays on the someday shelf while survival makes the decisions.",
];

const WHAT_BECOMES_POSSIBLE = [
  "Name the area of your life that needs your attention first.",
  "Build new beliefs, boundaries, rhythms, and priorities.",
  "Leave with a practical plan and support for living it.",
];

export const IdentityResetSections: React.FC = () => {
  return (
    <>
      {/* SECTION 3: Video + timestamps + price bar */}
      <section className="bg-[#FAF6F0] w-full py-16 md:py-24">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-5xl mx-auto space-y-6">
          <div className="relative w-full aspect-video bg-neutral-300 overflow-hidden rounded-2xl border border-[#E8DEC8]">
            <video
              src="https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a9b75fd3dd2068ce69acec3.mp4#t=1"
              controls
              playsInline
              preload="metadata"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 p-4 text-white text-xs font-bold uppercase tracking-widest z-10 drop-shadow pointer-events-none">
              IDENTITY RESET HIGHLIGHTS
            </div>
          </div>

          <div className="bg-[#EFE6D2]/60 rounded-2xl border border-[#E8DEC8] p-6 sm:p-8">
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#9E1B50] block mb-1">
              TEACHING TIMESTAMPS
            </span>
            <h3 className="font-serif text-xl sm:text-2xl font-normal text-[#380C1E] mb-5">
              Go directly to what you need.
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3">
              {TIMESTAMPS_LEFT.map((t) => (
                <div
                  key={t.time}
                  className="flex items-center gap-4 text-xs sm:text-sm text-[#380C1E]/80"
                >
                  <span className="text-[#9E1B50] font-bold font-mono w-12 shrink-0">
                    {t.time}
                  </span>
                  <span className="font-light">{t.label}</span>
                </div>
              ))}
              {TIMESTAMPS_RIGHT.map((t) => (
                <div
                  key={t.time}
                  className="flex items-center gap-4 text-xs sm:text-sm text-[#380C1E]/80"
                >
                  <span className="text-[#9E1B50] font-bold font-mono w-12 shrink-0">
                    {t.time}
                  </span>
                  <span className="font-light">{t.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-[#4A0E26] text-white rounded-2xl p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <div>
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/60 block mb-1">
                AVAILABLE FOR PURCHASE
              </span>
              <p className="font-serif text-lg sm:text-xl">
                Keep the full Identity Reset experience.
              </p>
              <p className="text-[10px] text-white/70 font-light pt-1">
                Licensed for personal use only. Full license:{" "}
                <Link
                  to="/product-license"
                  className="underline hover:text-white"
                >
                  iamieshiadanielle.com/product-license
                </Link>
              </p>
            </div>
            <div className="flex items-center gap-4">
              <span className="font-serif text-2xl sm:text-3xl font-semibold">
                $47
              </span>
              <a
                href="https://store.iamieshiadanielle.com/product-details/product/6a9990d12ec6f6c3e6a0fe7f"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-[#4A0E26] font-bold uppercase text-[11px] tracking-wider px-6 py-3 rounded-full hover:bg-[#FAF6F0] transition-all whitespace-nowrap"
              >
                ADD TO CART →
              </a>
            </div>
          </div>

          <div className="flex justify-center pt-2">
            <a
              href="https://store.iamieshiadanielle.com/product-details/product/6a98cd6f86a8dfe2ef9d9ef1/?variant=6a98cd6f86a8dfe2ef9d9ef9"
              className="w-full sm:w-auto text-center bg-[#9E1B50] text-white font-bold uppercase text-[11px] tracking-wider px-6 py-3.5 rounded-full hover:bg-[#801440] transition-all"
            >
              SAVE WHEN YOU BUNDLE IDENTITY RESET WITH THE WORKBOOK →
            </a>
          </div>
        </div>
      </section>

      {/* SECTION 5: Quiz strip */}
      <section className="bg-[#9E1B50] w-full py-8 md:py-10">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-center sm:text-left">
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/70 block">
              YOUR NEXT CLEAR STEP
            </span>
            <p className="font-serif text-xl sm:text-2xl text-white">
              Where is your burnout coming from?
            </p>
          </div>
          <a
            href="https://quiz.iamieshiadanielle.com/quiz"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-[#9E1B50] font-bold uppercase text-[11px] tracking-wider px-8 py-3.5 rounded-full hover:bg-[#FAF6F0] transition-all whitespace-nowrap"
          >
            TAKE THE QUIZ →
          </a>
        </div>
      </section>

      {/* SECTION 6: What shifted */}
      <section className="bg-white w-full py-16 md:py-24">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-6xl mx-auto space-y-8">
          <div>
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#9E1B50] block mb-2">
              HEAR IT IN THEIR OWN WORDS
            </span>
            <h2 className="font-serif text-3xl md:text-4xl font-normal text-[#380C1E]">
              What shifted after Identity Reset.
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {[
              {
                quote: "A weight was lifted",
                who: "IDENTITY RESET ATTENDEE",
                video:
                  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a957c5de68555d6d5e84517.mp4",
              },
              {
                quote: "I realized I was not alone",
                who: "IDENTITY RESET ATTENDEE",
                video:
                  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a957c5d9ced56098acdbb34.mp4",
              },
              {
                quote: "It was time to do the work",
                who: "IDENTITY RESET ATTENDEE",
                video:
                  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a957c5d648f56e7e42e21e1.mp4",
              },
            ].map((item, idx) => (
              <div key={idx} className="space-y-3">
                <div className="relative aspect-[4/5] rounded-xl overflow-hidden bg-neutral-300 border border-[#E8DEC8]">
                  <video
                    src={`${item.video}#t=0.1`}
                    controls
                    playsInline
                    preload="metadata"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </div>
                <p className="font-serif text-sm sm:text-base text-[#380C1E]">
                  {item.quote}
                </p>
                <span className="text-[10px] font-bold uppercase tracking-widest text-[#380C1E]/50 block">
                  {item.who}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 7: Bundle banner */}
      <section
        id="bundle"
        className="bg-[#4A0E26] text-white w-full py-16 md:py-24"
      >
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5 flex justify-center">
            <div className="w-full max-w-sm aspect-square rounded-2xl overflow-hidden border border-white/20 relative shadow-xl">
              <img
                src="https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a957aeff22eac14d9b5abff.jpg"
                alt="Identity Reset workshop and From Burnout to Becoming workbook bundle"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
          <div className="lg:col-span-7 space-y-5">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-white/70 block">
              SAVE WHEN YOU BUNDLE
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-normal leading-tight">
              Watch the teaching. Then do the work on paper.
            </h2>
            <p className="text-sm sm:text-base text-white/80 font-light leading-relaxed max-w-xl">
              Pair Identity Reset with the From Burnout to Becoming workbook for
              the guided teaching and the written reflection.
            </p>
            <div className="flex items-baseline gap-4 pt-1">
              <span className="font-serif text-3xl sm:text-4xl font-semibold">
                $55
              </span>
              <span className="text-[10px] font-bold uppercase tracking-wider text-white/60">
                IDENTITY RESET + PHYSICAL OR DIGITAL WORKBOOK
              </span>
            </div>
            <a
              href="https://store.iamieshiadanielle.com/product-details/product/6a98cd6f86a8dfe2ef9d9ef1/?variant=6a98cd6f86a8dfe2ef9d9ef9"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-white text-[#4A0E26] font-bold uppercase text-[11px] tracking-wider px-8 py-4 rounded-xl hover:bg-[#FAF6F0] transition-all"
            >
              EXPLORE THE BUNDLE →
            </a>
          </div>
        </div>
      </section>

      {/* SECTION 8: Join the Becoming Intensive */}
      <section className="bg-[#9E1B50] text-white w-full py-16 md:py-24">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <div className="w-full aspect-[4/5] rounded-2xl overflow-hidden border border-white/20 relative shadow-xl">
              <img
                src="https://vibe.filesafe.space/1787853701390843161/attachments/1343b564-0998-4c87-aaf8-2bb4c444e9bf.jpg"
                alt="Ieshia Danielle teaching at workshop"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="lg:col-span-7 space-y-5">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-white/70 block">
              READY FOR THE GUIDED WALK?
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-normal leading-tight">
              Join the Becoming Intensive.
            </h2>
            <p className="text-sm sm:text-base text-white/85 font-light leading-relaxed max-w-xl">
              The workbook is the map. The Intensive is the six-week guided walk
              with Ieshia, structure, coaching, and accountability.
            </p>
            <Link
              to="/programs/becoming-intensive"
              className="inline-block bg-white text-[#9E1B50] font-bold uppercase text-[11px] tracking-wider px-8 py-4 rounded-xl hover:bg-[#FAF6F0] transition-all"
            >
              EXPLORE THE INTENSIVE →
            </Link>
          </div>
        </div>
      </section>

      {/* SECTION 9: Clarity vs plan */}
      <section className="bg-white w-full py-16 md:py-24 border-t border-[#E8DEC8]">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-6xl mx-auto space-y-10">
          <div className="max-w-3xl space-y-3">
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#9E1B50] block">
              WHEN CLARITY NEEDS A PLAN
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-normal text-[#380C1E] leading-[1.15]">
              Knowing what needs to change is not the same as knowing how to
              change it.
            </h2>
            <p className="text-xs sm:text-sm text-[#380C1E]/70 font-light leading-relaxed">
              Identity Reset helps you name the beliefs, roles, and survival
              patterns that have been shaping your choices. The Becoming
              Intensive gives you six weeks to work through the six Bs with
              teaching, coaching, structure, and accountability, so your clarity
              becomes a life you can actually sustain.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-[#EFE6D2]/60 rounded-2xl border border-[#E8DEC8] p-6 space-y-3">
              <span className="text-[10px] font-bold uppercase tracking-widest text-[#380C1E]/60 block">
                WHAT STAYING THE SAME COSTS
              </span>
              <ul className="space-y-2">
                {WHAT_STAYS_THE_SAME.map((item, idx) => (
                  <li
                    key={idx}
                    className="flex items-start gap-2 text-xs sm:text-sm text-[#380C1E]/80 font-light"
                  >
                    <span className="text-[#9E1B50] mt-0.5">✓</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-[#F5E9EC] rounded-2xl border border-[#E8DEC8] p-6 space-y-3">
              <span className="text-[10px] font-bold uppercase tracking-widest text-[#9E1B50] block">
                WHAT BECOMES POSSIBLE
              </span>
              <ul className="space-y-2">
                {WHAT_BECOMES_POSSIBLE.map((item, idx) => (
                  <li
                    key={idx}
                    className="flex items-start gap-2 text-xs sm:text-sm text-[#380C1E]/80 font-light"
                  >
                    <span className="text-[#9E1B50] mt-0.5">✓</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="bg-[#380C1E] text-white rounded-2xl p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <p className="text-xs sm:text-sm text-white/80 font-light">
                Six weeks. Live guidance. Scripture-rooted transformation.
              </p>
              <span className="font-serif text-xl sm:text-2xl font-semibold">
                $997
              </span>
            </div>
            <Link
              to="/programs/becoming-intensive"
              className="bg-[#9E1B50] hover:bg-[#801440] text-white font-bold uppercase text-[11px] tracking-wider px-6 py-3 rounded-full transition-all whitespace-nowrap"
            >
              LEARN MORE ABOUT THE INTENSIVE →
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};
